import axios from "axios";
import { toast } from "react-toastify";
import { store } from "../../../../Redux/Store";
import { attendanceDashboardV2 } from "../../../../text/apidata";

const authHeader = () => ({
  Authorization: "Bearer " + store.getState().users.UserData.session.token,
});

// Drop empty filter values so the API only sees what the user picked
export const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== "" && v !== "all_values"
    )
  );

const handleError = (error) => {
  if (axios.isCancel(error)) return;
  const status = error?.response?.data?.status;
  if (status?.code === 401) {
    localStorage.clear();
    window.location.href = "/";
    return;
  }
  toast.error(status?.message || "Could not load attendance data.", {
    position: toast.POSITION.TOP_RIGHT,
  });
};

export const getDashboard = async (path, params, signal) => {
  try {
    const response = await axios.get(attendanceDashboardV2 + path, {
      params: cleanParams(params),
      headers: authHeader(),
      signal,
    });
    return response.data.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const downloadExport = async (params) => {
  try {
    const response = await axios.get(attendanceDashboardV2 + "export/", {
      params: cleanParams(params),
      headers: authHeader(),
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `attendance_${params.from_date}_${params.to_date}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    handleError(error);
  }
};
